// extracted by mini-css-extract-plugin
export default {"highlightedText":"AboutMe_highlightedText__tAvZf"};